<template>
    <aside class="sidebar">
      <ul class="tree-list">
        <TreeNode v-for="node in tree" :key="node.name" :node="node" :active-path="activePath" @select="onSelect" />
      </ul>
    </aside>
  </template>
  
  <script>
  // import loadMarkdownFiles from "@/utils/loadMarkdown";
  import generateTree from "@/utils/generateTree";
  import TreeNode from "./TreeNode.vue";
  
  export default {
    name: "side-bar",
    components: {
        TreeNode
    },
    props: {
      defaultPath: {
        type: String,
        default: 'wiki'
      },
      files: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        tree: [],
        activePath: ''
      };
    },
    mounted() {
      this.tree = generateTree(this.files);
      console.log("this.tree=========");
      console.log(this.defaultPath);
      console.log(this.tree);
      if (this.files.length > 0) {
        this.activePath = this.files[0].path;
      }
    },
    methods: {
      onSelect(path) {
        this.activePath = path;
        this.$router.push(`/${this.defaultPath}${path}`);
        this.$emit("file-selected");
      },
    },
  };
  </script>
  
  <style scoped>
  .sidebar {
    width: 260px;
    height: calc(100vh - 50px); /* 减去顶部状态栏的高度 */
    background-color: var(--bg-secondary);
    border-right: 1px solid var(--border-color);
    overflow-y: auto;
    padding: 1rem;
    color: var(--text-primary);
  }
  
  @media (max-width: 768px) {
    .sidebar {
      width: 280px; /* 移动端稍微宽一点 */
      box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
    }
  }
  
  .tree-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  /* 滚动条样式 */
  .sidebar::-webkit-scrollbar {
    width: 6px;
  }
  
  .sidebar::-webkit-scrollbar-track {
    background: transparent;
  }
  
  .sidebar::-webkit-scrollbar-thumb {
    background-color: var(--text-secondary);
    border-radius: 3px;
  }
  
  .sidebar::-webkit-scrollbar-thumb:hover {
    background-color: var(--text-primary);
  }
  
  /* 深色模式样式 */
  :global(body.dark-mode) .sidebar {
    background-color: #1a1a1a;
    border-right-color: #2d2d2d;
  }
  
  :global(body.dark-mode) .sidebar::-webkit-scrollbar-thumb {
    background-color: #666;
  }
  </style>